import { render } from "./SquareOrders.vue?vue&type=template&id=38d15136&scoped=true"
import script from "./SquareOrders.vue?vue&type=script&lang=js"
export * from "./SquareOrders.vue?vue&type=script&lang=js"

import "./SquareOrders.vue?vue&type=style&index=0&id=38d15136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d15136"]])

export default __exports__